import { createInternalAccountTransfer } from "../../../services/api/banking/internalAccounts";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_BOOKKEEPING_BANKING_BALANCE } from "../../bookkeeping/keys";
import { useWSMutation, WSMutationConfig } from "../../helpers";
import { QUERY_TAXES_WITHHOLDING_BALANCE } from "../../taxes/keys";
import { QUERY_INTERNAL_ACCOUNT_BALANCE } from "../queries/useQueryInternalAccountBalance";
import { QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS } from "../queries/useQueryListInternalAccountTransactions";

export const useMutationCreateInternalAccountTransfer = (
  config?: WSMutationConfig<
    Awaited<ReturnType<typeof createInternalAccountTransfer>>,
    WSServiceError,
    Parameters<typeof createInternalAccountTransfer>[1]
  >
) =>
  useWSMutation<
    Awaited<ReturnType<typeof createInternalAccountTransfer>>,
    WSServiceError,
    Parameters<typeof createInternalAccountTransfer>[1]
  >(
    requestData =>
      createInternalAccountTransfer(requestData.internalAccountId, requestData),
    {
      ...config,
      dependencies: [
        QUERY_INTERNAL_ACCOUNT_BALANCE,
        QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS,
        QUERY_BOOKKEEPING_BANKING_BALANCE,
        QUERY_TAXES_WITHHOLDING_BALANCE
      ]
    }
  );
